var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9408 5.29009C35.9539 5.22557 36.0461 5.22557 36.0593 5.29009C36.7438 8.63906 39.361 11.2562 42.71 11.9408C42.7745 11.9539 42.7745 12.0461 42.71 12.0593C39.361 12.7438 36.7438 15.361 36.0593 18.71C36.0461 18.7745 35.9539 18.7745 35.9408 18.71C35.2562 15.361 32.6391 12.7438 29.2901 12.0593C29.2256 12.0461 29.2256 11.9539 29.2901 11.9408C32.6391 11.2562 35.2562 8.63906 35.9408 5.29009Z",
    stroke: "#B3FF10",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12H22M7 36H41M36 41V26M12 41V7",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsIcon);
export default __webpack_public_path__ + "static/media/metrics-icon.fd52f6f7b6756ec59df2f7a96ba7aaca.svg";
export { ForwardRef as ReactComponent };